import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../routes";
import { updateProspect } from "../../store/actions/appConfig";
import { MULTI_PARTNER_PERSONA, OtpChannel, Personas, UAE_CODE } from "../../constants";
import { useTrackingHistory } from "../../utils/useTrackingHistory";
import { OverlayLoader } from "../../components/Loader";
import { getDocumentsList } from "../../store/actions/uploadDocuments";
import { setOtpMode } from "../../store/actions/otp";
import { setSelectedStakeholderId } from "../../store/actions/stakeholders";

export default function RestartOTP({ generateOtp, prospectInfo }) {
  const pushHistory = useTrackingHistory();
  const dispatch = useDispatch();
  const application = useLocation().state?.application;
  const sid = useLocation().state?.signatoryId;
  const navigate = useNavigate();

  const { maxAttemptsExceeded } = useSelector(state => state.otp);
  if (maxAttemptsExceeded) {
    // go back to previous route
    navigate(routes.comeBackLogin);
  }
  useEffect(() => {
    const otpMode = OtpChannel.Email;
    const otpGenerationPayload = {
      email: application?.applicantInfo?.email,
      countryCode: application?.applicantInfo?.countryCode,
      mobileNo: application?.applicantInfo?.mobileNo,
      action: "generate",
      mode: otpMode,
      prospectId: application?.prospectId,
      sid
    };
    dispatch(
      updateProspect({
        "prospect.applicantInfo.countryCode": UAE_CODE,
        "prospect.applicantInfo.mobileNo": application?.applicantInfo?.mobileNo,
        "prospect.applicantInfo.email": application?.applicantInfo?.email || ""
      })
    );

    generateOtp(otpGenerationPayload).then(
      () => {
        dispatch(setOtpMode(otpMode));
        prospectInfo(application?.prospectId).then(
          prospect => {
            const { companyFullName, persona } = prospect.applicantInfo;
            const isMultiPartnerJourney = MULTI_PARTNER_PERSONA.includes(persona);
            const selectedPersona = Personas[persona];

            if (isMultiPartnerJourney) {
              dispatch(setSelectedStakeholderId(sid));
            }

            dispatch(getDocumentsList());
            dispatch(
              updateProspect({
                "prospect.userJourneyType": "comeBackLogin",
                "prospect.applicantInfo.persona": persona,
                "prospect.organizationInfo.companyName": companyFullName.trim(),
                "prospect.organizationInfo.shortName":
                  companyFullName.length <= 50 ? companyFullName.trim() : "",
                "prospect.organizationInfo.companyCategory": selectedPersona?.companyCategoryCode
                  ? selectedPersona.companyCategoryCode
                  : ""
              })
            );
            pushHistory(routes.verifyEmailOtp, true);
          },
          () => {}
        );
      },
      () => {}
    );
  }, []);
  return <OverlayLoader open={true} text={"Loading"} />;
}
